/**
 * Edit Network Site Form Schema
 *
 * For now this reuses the Add Network Site schema and API transform,
 * but loads its own YAML config so we can customize metadata (title,
 * description, button labels) specifically for edit flows.
 */

import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'
import {
  AddNetworkSiteFormSchema,
  type AddNetworkSiteFormData,
  transformToApiRequest as addTransformToApiRequest,
} from '../addNetworkSite/schema'

// ============================================================================
// Export Form Metadata from YAML
// ============================================================================

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

// ============================================================================
// Schema & Types
// ============================================================================

export const EditNetworkSiteFormSchema = AddNetworkSiteFormSchema
export type EditNetworkSiteFormData = AddNetworkSiteFormData

// ============================================================================
// API Request Transformation
// ============================================================================

export function transformToApiRequest(formData: EditNetworkSiteFormData) {
  return addTransformToApiRequest(formData)
}

